import React from 'react';
import Navbar from './component/pages/Navbar';
import './component/assets/css/style.css';
import Home from './component/pages/Home';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Contact from './component/pages/Contact';
import Video from './component/pages/Video';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Footer from './component/pages/Footer';

// 👉 Add this import
import ScrollTopButton from './component/pages/ScrollTopButton';
import OurTeam from './component/pages/OurTeam';
import About from './component/pages/About';
import NewSubmenu1 from './component/pages/newsubmenu1';
import Publications from './component/assets/publications/Publications';
import Blogs from './component/assets/publications/Blogs';
import Litigation from './component/pages/Rand self';
// import Ourteamabout from './component/pages/Ourteamabout';

function App() {
  return (
    <Router>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/video" element={<Video />} />
        <Route path="/ourteam" element={<OurTeam />} />
        <Route path="/about" element={<About />} />
        <Route path="/submenu" element={<NewSubmenu1 />} />
         <Route path="/litigation" element={<Litigation />} />
        <Route path="/publications" element={<Publications />} />
        <Route path="/blogs" element={<Blogs />} />
         {/* <Route path="/team-about" element={<Ourteamabout />} /> */}
      </Routes>

      {/*  Scroll To Top Button */}
      <ScrollTopButton />

      <Footer />
    </Router>
  );
}

export default App;
